module.exports = __webpack_public_path__ + "img/ico-check-pink-quest.8ad0c95b.svg";